export const INVALID_EMAIL_ERROR = 'Invalid email'
export const INVALID_PASSWORD_ERROR = 'Invalid password'
export const INVALID_PHONE_ERROR = 'Invalid phone number. Please provide a valid international phone number including the country code.'
export const USER_ALREADY_EXISTS_ERROR = 'A user with this email already exists.'
export const USER_NOT_FOUND_ERROR = 'User not found'

